import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Headline } from 'ViatoUi/Shared/Typo';
import Scrollable from 'ViatoUi/Shared/Utilities/Scrollable';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

import styles from './DimmerPopup.module.scss';

const DimmerPopup = ({ visible, onClick, children, headline, buttonText, footerContent, fixedContent, isLarge }) => {
	useEffect(() => {
		if (visible) {
			document.body.classList.add('scrolling-disabled');
		} else {
			document.body.classList.remove('scrolling-disabled');
		}
	}, [visible]);

	return (
		<div className={styles.popup} data-checked={visible} data-is-large={isLarge}>
			<div className={styles.inner}>
				<div className={styles.bg}>
					<Headline type='h3'>{headline}</Headline>
					<Spacer height='m' />
					<div className='textWrap'>
						<Scrollable className={styles.text}>
							<div className={styles.innerText}>{children}</div>
						</Scrollable>
					</div>
					{fixedContent}
					<Spacer height='l' />
					<div className={styles.footer}>
						{buttonText !== null && (
							<Button type='dark' onClick={() => onClick()}>
								{buttonText}
							</Button>
						)}
						{footerContent}
					</div>
				</div>
			</div>
		</div>
	);
};

DimmerPopup.propTypes = {
	visible: PropTypes.bool,
	isLarge: PropTypes.bool,
	headline: PropTypes.string.isRequired,
	buttonText: PropTypes.string,
	onClick: PropTypes.func,
	children: PropTypes.node,
	fixedContent: PropTypes.node,
	footerContent: PropTypes.node
};

DimmerPopup.defaultProps = {
	visible: false,
	isLarge: false,
	children: null,
	buttonText: null,
	fixedContent: null,
	footerContent: null,
	onClick: () => {}
};

export default DimmerPopup;
